import { Component, OnInit, ViewChild } from '@angular/core';
import { KmsService } from '../../../kms.service';
import { SwMassageBoxService } from '../../../../../librarys/serves/sw-massage-box.service';
import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { LabelAddComponent } from '../label-add/label-add.component';
declare var $;
@Component({
    selector: 'app-label-query',
    templateUrl: './label-query.component.html',
    styleUrls: ['./label-query.component.css']
})
export class LabelQueryComponent implements OnInit {
    @ViewChild("swtable") swtable: SwGridTableComponent;
    @ViewChild("trim") trim: SwMassageConfirmComponent;     //确认删除弹框
    // 是否显示内容
    loadingGroup = {
        treeLoading: false,  // 标签分类树是否显示加载中
        tableLoading: false  // 表格是否显示加载中
    }
    // 左侧搜索标签名称
    searchTagName = '';
    // 左侧标签分类树中选中的标签分类id
    parentId = '';
    // 右侧头部标签搜索名
    tagName = '';
    // 标签分类树数据
    tagTreeDatas = [];
    // 表格数据
    datas: any = [];
    // 当前选中的数据
    selectedData: any = [];
    // 表格分页组件
    pageBase: any = {
        current: 1,
        size: 10
    }
    // 表格操作按钮
    toolbar = [
        { status: true, functionCode: 'add', functionName: '新增', icon: 'glyphicon glyphicon-plus', children: [] },
        { status: true, functionCode: 'delete', functionName: '批量删除', icon: 'glyphicon glyphicon-remove', children: [] },
        // { status: true, functionCode: 'import', functionName: '导入', icon: 'glyphicon glyphicon-import', children: [] },
        // { status: true, functionCode: 'export', functionName: '导出', icon: 'glyphicon glyphicon-export', children: [] }
    ];
    //是否展示左侧菜单
    showLeft:boolean = true  
    constructor(
        private kmsService: KmsService,
        private box: SwMassageBoxService,
        private create: SwCreateModalComponentService
    ) { }

    ngOnInit() {
        // 查询左侧标签分类树
        this.getTagTreeData();
        // 查询右侧标签列表
        this.handleSelectClick();
    }

    // 标签搜索框回车搜索方法
    treeEnterSearch(event) {
        if (event.keyCode == '13') {
            this.getTagTreeData();
        }
    }

    // 请求标签分类树数据方法
    getTagTreeData() {
        this.tagTreeDatas = [];
        this.loadingGroup.treeLoading = true;
        let keyword = $.trim(this.searchTagName);
        let params = {
            tagName: keyword,
        }
        this.kmsService.queryTagTree(params).subscribe(result => {
            if (result.code == 200) {
                this.loadingGroup.treeLoading = false;
                if (result.data.length == 0) {
                    if(keyword){
                        this.box.danger('当前标签分类不存在！');
                    }
                    return;
                }
                let datas = result.data
                this.tagTreeDatas = datas;
                this.tagTreeDatas.forEach(item => {
                    item['id'] = item['tagId'];
                    item['pid'] = item['parentId'] ? item['parentId'] : '0';
                    item['text'] = item['tagName'];
                });
                const rootNode = {
                    'id': '0',
                    'pid': null,
                    'text': '标签分类',
                    'tagId': '0',
                    'tagName': '标签分类'
                };
                this.tagTreeDatas.push(rootNode);
            }
        });
    }

    // 左侧树模型点击事件
    handleVotedClick(event) {
        // 点击左侧分类切换标签列表
        this.parentId = event.key;
        this.handleSelectClick();
    }

    // enter键触发搜索
    enterSearch(event) {
        if (event.keyCode == '13') {
            this.handleSelectClick();
        }
    }

    // 查询按钮方法
    handleSelectClick() {
        this.pageBase = {
            current: 1,
            size: 10
        };
        this.getData();
    }

    //获取数据
    getData() {
        this.loadingGroup.tableLoading = true;
        const params = {
            'tagName': $.trim(this.tagName),
            'parentId': this.parentId == '0' ? '' : this.parentId,
            'current': this.pageBase.current,
            'size': this.pageBase.size
        }
        this.kmsService.queryTagList(params).subscribe(
            data => {
                this.loadingGroup.tableLoading = false;
                if (data.code == '200') {
                    this.pageBase = data.data;
                    this.datas = data.data.records;
                } else {
                    this.box.waring(data.msg);
                }
            }
        );
    }

    // 刷新页面数据
    refresh(){
        this.getTagTreeData();
        this.handleReloadClick();
    }

    // 刷新页面数据
    refresh1(){
        this.getTagTreeData();
        this.getData();
    }

    // 按钮点击事件
    handleOperationClick(event) {
        switch (event) {
            case "add": this.handleAddClick(); break; // 新增
            case 'delete': this.handleDeleteClick(); break; // 删除
            case 'import': this.handleImportClick(); break; // 导入
            case 'export': this.handleExportClick(); break; // 导出
        }
    }

    // 新增方法
    handleAddClick() {
        let param = { "upOrAdd": "Add", "selectedData": null,"parentId": this.parentId };
        this.create.createModal(LabelAddComponent, param, this.refresh.bind(this))
    }

    // 批量删除
    handleDeleteClick() {
        if (this.selectedData.length == 0) {
            this.box.danger('请至少选择一条数据！');
            return;
        }
        let ids = [];
        this.selectedData.forEach(item => {
            ids.push(item.tagId);
        });
        this.delete(ids);
    }

    // 导入
    handleImportClick(){

    }

    // 导出
    handleExportClick(){
        
    }

    /**
    * 点击td中的按钮
    * @ignore
    */
    clickTdBtn(type, data) {
        //禁止冒泡
        event.stopPropagation();
        // 编辑
        if (type == 'edit') {
            let param = { "upOrAdd": "Edit", "selectedData": data ,"parentId": this.parentId};
            this.create.createModal(LabelAddComponent, param, this.refresh1.bind(this))
        }
        // 删除
        else if (type == 'delete') {
            this.delete([data.tagId]);
        }
    }

    // 表格选中行数据
    handleSelectData(event) {
        //获取当前选中的所有数据
        this.selectedData = event;
        //设置表格按钮组状态
        this.swtable.toolbarAllEnable();
        if (this.selectedData.length == 0) {
            this.swtable.toolbarDisable("delete");
        };
    }

    // 表格分页点击方法
    handlePageClick(event) {
        this.pageBase = event;
        this.getData();
    }

    // 重置数据
    handleReloadClick() {
        this.tagName = '';
        this.pageBase = {
            current: 1,
            size: 10
        };
        this.getData();
    }

    // 删除方法
    delete (ids) {
        this.trim.openCLick("确认删除吗？", (data) => {
            if (data) {
                this.kmsService.deleteTagById(ids).subscribe(
                    data => {
                        if (data["code"] == '200') {
                            this.box.success("操作成功");
                            this.refresh();
                        } else {
                            this.box.waring(data.msg);
                        }
                    }
                )
            }
        })
    }

    // 左侧菜单切换
    showStyle(data) {
        this.showLeft=!data;
    }
}
